import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from "react-redux"
import { marcarComicion, marcarTodasComicion } from "../../../ducks/cotizacionDuck"
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Tooltip from '@material-ui/core/Tooltip'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import WarningIcon from '@material-ui/icons/Warning'
import EventBusy from '@material-ui/icons/EventBusy'
import green from '@material-ui/core/colors/green'
import yellow from '@material-ui/core/colors/yellow'
import red from '@material-ui/core/colors/red'
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
import Avance from "./../../../global/Avance"
import { formatDinero } from '../../../utils/formatDinero'
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
const columns = [
    { id: "1", minWidth: 0, align: "center", label: 'Cliente' },
    { id: "2", minWidth: 0, align: "center", label: 'Cotización' },
    { id: "3", minWidth: 0, align: "center", label: 'Referencia' },
    { id: "4", minWidth: 0, align: "center", label: 'Moneda' },
    { id: "5", minWidth: 0, align: "center", label: 'Monto paquete' },
    { id: "6", minWidth: 0, align: "center", label: "Avance" },
    { id: "7", minWidth: 0, align: "center", label: "Avance %" },
    { id: "8", minWidth: 0, align: "center", label: "Estatus" }
]

const columnsReporte = [
    { id: "9", minWidth: 0, align: "center", label: 'Cliente' },
    { id: "10", minWidth: 0, align: "center", label: 'Cotización' },
    { id: "11", minWidth: 0, align: "center", label: 'Referencia' }
]

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
})

const TMisComisiones = ({ rows, isPago, isReporte }) => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [checked, setChecked] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0)
    }

    const handleChangeCheckAll = (event) => {
        document.body.style.cursor = 'wait'
        dispatch(onLoadAnction({}))
        dispatch(marcarTodasComicion(!checked)).then((Response) => {
            dispatch(offLoadAction())
            document.body.style.cursor = 'default'
            setChecked(!checked);
        })
    }

    const handleChangeCheckDinamic = (MarcadoPago, idCotizacion) => {
        document.body.style.cursor = 'wait'
        dispatch(onLoadAnction({}))
        dispatch(marcarComicion(idCotizacion, !MarcadoPago)).then((Response) => {
            dispatch(offLoadAction())
            document.body.style.cursor = 'default'
        })
    }


    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {
                                !isReporte &&
                                columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))
                            }
                            {
                                isReporte &&
                                columnsReporte.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))
                            }
                            {
                                isPago &&
                                <TableCell
                                    align={'center'}
                                    value={checked}
                                    onChange={handleChangeCheckAll}
                                >
                                    <input type="checkbox" id="checkTodos" />
                                </TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            if (!isReporte) {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.Movimiento?.Referencia}>
                                        <TableCell align="center">
                                            {`${row.Movimiento.Cuenta.Nombre} ${row.Movimiento.Cuenta.Apellido_Paterno} ${row.Movimiento.Cuenta.Apellido_Materno}`}
                                        </TableCell>
                                        <TableCell align="center">{row.idCotizacion}</TableCell>
                                        <TableCell align="center">
                                            <ButtonClienteDetalle referencia={row.Movimiento.Referencia} />
                                        </TableCell>
                                        <TableCell align="center">{row.Moneda.Nombre}</TableCell>
                                        <TableCell align="center">{formatDinero(row.paquete.Monto_Paquete)}</TableCell>
                                        <TableCell align="center">{formatDinero(row.Suma)}</TableCell>
                                        <TableCell align="center">
                                            <Avance progress={row.Avance} label={false} />
                                        </TableCell>
                                        {
                                            !isReporte &&
                                            <TableCell align="center">
                                                {row.icono === 1 &&
                                                    <Tooltip title={row.Estatus}>
                                                        <EventAvailableIcon style={{ color: green[500] }} />
                                                    </Tooltip>
                                                }
                                                {row.icono === 2 &&
                                                    <Tooltip title={row.Estatus}>
                                                        <WarningIcon style={{ color: yellow[700] }} />
                                                    </Tooltip>
                                                }
                                                {row.icono === 3 &&
                                                    <Tooltip title={row.Estatus}>
                                                        <EventBusy style={{ color: red[700] }} />
                                                    </Tooltip>
                                                }
                                            </TableCell>
                                        }

                                        {
                                            isPago &&
                                            <TableCell align="center">
                                                <input type="checkbox"
                                                    value={row.idCotizacion}
                                                    checked={row.MarcadoPago}
                                                    onChange={() => handleChangeCheckDinamic(row.MarcadoPago, row.idCotizacion)} />
                                            </TableCell>
                                        }
                                    </TableRow>
                                );
                            }

                            if (isReporte) {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.Movimiento?.Referencia}>
                                        <TableCell align="center">
                                            {`${row.Movimiento.Cuenta.Nombre} ${row.Movimiento.Cuenta.Apellido_Paterno} ${row.Movimiento.Cuenta.Apellido_Materno}`}
                                        </TableCell>
                                        <TableCell align="center">{row.idCotizacion}</TableCell>
                                        <TableCell align="center">
                                            <ButtonClienteDetalle referencia={row.Movimiento.Referencia} />
                                        </TableCell>
                                    </TableRow>
                                );
                            }
                            return null
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    )
}

export default TMisComisiones